import { render, staticRenderFns } from "./right-selector-new.vue?vue&type=template&id=45db2e12&scoped=true"
import script from "./right-selector-new.vue?vue&type=script&lang=js"
export * from "./right-selector-new.vue?vue&type=script&lang=js"
import style0 from "./right-selector-new.vue?vue&type=style&index=0&id=45db2e12&prod&lang=less"
import style1 from "./right-selector-new.vue?vue&type=style&index=1&id=45db2e12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45db2e12",
  null
  
)

export default component.exports